var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment-plans gantt-scroll",
      style: { width: _vm.width, height: "100vh", paddingTop: 0 },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "closer" },
          [
            _c("icon-button", {
              attrs: { icon: { name: "close-1", type: "bold" }, size: "small" },
              on: { onClick: _vm.close },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title-h1" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locales("plans_popup_title")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.isTrial
                ? _c("inline-notification", {
                    attrs: {
                      type: "info",
                      text: _vm.locales(
                        "pricing_page_trial_title_notification",
                        { planName: "Business" }
                      ),
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body" },
          [
            _c("payment-plans-widget", {
              attrs: {
                plans: _vm.plans,
                "users-count-list": _vm.dropdownUsersSelection,
                selected: _vm.selectedUsers,
                "is-annual": _vm.isAnnual,
                "is-popup": false,
              },
              on: {
                toggleAnnual: _vm.toggleAnnual,
                buyPlanClick: _vm.buyPlanClick,
                upgradePlanClick: _vm.upgradePlanClick,
                changeUserCount: _vm.changeUserCount,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { ref: "studentsSection", staticClass: "students-container" },
              [
                _c("div", { staticClass: "students" }, [
                  _c("div", { staticClass: "students__inner" }, [
                    _c("p", { staticClass: "students__title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.locales("plans_students_title")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "students__desc",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.locales("plans_students_description")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "students__btn" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--transparent",
                          on: { click: _vm.studentsClick },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.locales("learn_more")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "features",
                staticClass: "features border-wrapper",
                attrs: { id: "features" },
              },
              [
                _c("div", { ref: "table", staticClass: "table" }, [
                  _c("div", { ref: "tableHead", staticClass: "table-head" }, [
                    _c(
                      "div",
                      {
                        ref: "tableHeadTitle",
                        staticClass: "table-head-title",
                      },
                      [
                        _c("div", { staticClass: "features-title title-h2" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.locales("pricing_plans_features_table_head")
                              ) +
                              "\n              "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "head-plans-wrapper" },
                      _vm._l(_vm.plans, function (plan, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: ["table-plan-cell head-cell", plan.name],
                          },
                          [
                            plan.name !== "enterprise"
                              ? _c("div", { staticClass: "inner-info" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "plan-name",
                                      style: { textTransform: "capitalize" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(plan.plan_name) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "price-desc" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s("$ " + plan.price) +
                                        " USD\n                  "
                                    ),
                                  ]),
                                ])
                              : _c("div", { staticClass: "inner-info" }, [
                                  _c("div", { staticClass: "plan-name" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.locales(
                                            plan.name + "_plan_locale"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "price-desc" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.locales(
                                            "pricing_custom_price_title"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "tableBody",
                      class:
                        "table-body " + (_vm.isCollapsed ? "collapsed" : ""),
                    },
                    _vm._l(_vm.featuresTable, function (group, index) {
                      return _c("table-group", {
                        key: index,
                        ref: "tableGroup",
                        refInFor: true,
                        attrs: { plans: _vm.plans, group: group },
                      })
                    }),
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "tableCollapse",
                    class:
                      "table-collapse " + (_vm.isCollapsed ? "collapsed" : ""),
                    on: {
                      click: function ($event) {
                        return _vm.collapseTable()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              "" +
                                (_vm.isCollapsed
                                  ? _vm.locales("pricing_table_collapse_hide")
                                  : _vm.locales("pricing_table_collapse_show"))
                            ) +
                            "\n            "
                        ),
                        _c("svgImage", {
                          attrs: { name: "pricing-table-collapse-icon" },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { ref: "faq", staticClass: "faq" }, [
              _c("div", { staticClass: "faq-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locales("faq_plans_locales")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "faq-list" },
                _vm._l(_vm.faqConfig, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "faq-item",
                      attrs: { "data-key": item.key },
                      on: { click: _vm.showAnswer },
                    },
                    [
                      _c("div", { staticClass: "question" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.question) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "check-icon" },
                        [
                          _c("webix-ui", {
                            attrs: { config: _vm.icons.checkIcon },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "answer",
                        domProps: { innerHTML: _vm._s(item.answer) },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { ref: "footer", staticClass: "contact-footer" }, [
              _c("div", { staticClass: "footer-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locales("plans_popup_footer_title")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "contact-us",
                domProps: {
                  innerHTML: _vm._s(_vm.locales("footer_contact_link_locale")),
                },
                on: { click: _vm.chatClick },
              }),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }